import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import asButton from '../decorator/asButton';
import IconComponent from './Icon';

const ItemListHeader = ({
  eventId,
  eventHandler,
  toggleBulkActions,
  getOrderAndDirection,
  getIsOrdered,
  isDescending,
  disableOrderAndDirection,
  columns,
  children
}) => (
  <dl data-bulkactions-visible={toggleBulkActions} data-not-allowed={disableOrderAndDirection}>
    {map(columns, (column) => {
      const { id, title, coerce, isDefault } = column;
      return (
        <dd
          key={id}
          {...asButton(
            undefined,
            disableOrderAndDirection ? undefined : eventId,
            disableOrderAndDirection ? undefined : eventHandler,
            {
              orderBy: id,
              coerceTo: coerce,
              isDescending
            }
          )}
          data-header-ordered={disableOrderAndDirection ? false : getIsOrdered(id, isDefault)}>
          <span>{title}</span>
          <IconComponent
            src={getOrderAndDirection(id, 'icon-keyboard-arrow-up', 'icon-keyboard-arrow-down')}
            caption={title}
          />
        </dd>
      );
    })}
    {children}
  </dl>
);

ItemListHeader.propTypes = {
  eventId: PropTypes.string.isRequired,
  eventHandler: PropTypes.func,
  toggleBulkActions: PropTypes.bool.isRequired,
  getOrderAndDirection: PropTypes.func.isRequired,
  getIsOrdered: PropTypes.func.isRequired,
  isDescending: PropTypes.bool.isRequired,
  disableOrderAndDirection: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};

ItemListHeader.defaultProps = {
  disableOrderAndDirection: false,
  eventHandler: () => {}
};

export default ItemListHeader;
